export const global = {
    accuracy: ['точность', 'accuracy'],
    actualVersion: ['Актуальная версия', 'Actual version'],
    add: ['Добавить', 'Add'],
    airport: ['Аэропорт', 'Airport'],
    allItems: ['Все', 'All items'],
    altAccuracy: ['Точность высоты', 'Alt accuracy'],
    altitude: ['высота', 'altitude'],
    at: ['в', 'at'],
    cancel: ['Отмена', 'Cancel'],
    cancelled: ['отменён', 'cancelled'],
    changeUser: ['Сменить пользователя', 'Change user'],
    clear: ['Очистить', 'Clear'],
    close: ['Закрыть', 'Close'],
    closed: ['Закрыт', 'Closed'],
    comment: ['Комментарий', 'Comment'],
    companySite: ['Сайт компании "АвиаБит"', 'Сайт компании "АвиаБит"'],
    confirmationDialog: ['Подтверждение', 'Confirmation dialog'],
    crewInfo: ['Сведения о членах экипажа', 'Crew info'],
    current: ['Текущий', 'Current'],
    currentLang: ['Язык', 'Language'],
    date: ['Дата', 'Date'],
    dateFrom: ['С', 'DATE FROM'],
    dateTo: ['ДО', 'DATE TO'],
    delete: ['Удалить', 'Delete'],
    download: ['Загрузить', 'Download'],
    downloadAll: ['Загрузить все', 'Download all'],
    downloaded: ['Загружен', 'Downloaded'],
    downloadRequired: ['Загрузить необходимые', 'Download required'],
    edit: ['Изменить', 'Edit'],
    employee: ['сотрудник', 'employee'],
    enableLocation: ['Включить геолокацию', 'Enable location'],
    enterMinutes: ['Введите минуты', 'Enter minutes'],
    errMessage: ['Сообщение об ошибке', 'Error message'],
    error: ['Ошибка', 'Error'],
    exit: ['Выход', 'Exit'],
    favorites: ['Избранное', 'Favorites'],
    filter: ['Фильтр', 'Filter'],
    flight: ['Рейс', 'Flight'],
    fuelInfo: ['Информация по топливу', 'Fuel info'],
    getData: ['Получить данные', 'Get data'],
    group: ['Группа доклада', 'Group'],
    info: ['Информация', 'Info'],
    latitude: ['широта', 'latitude'],
    left: ['ВЛЕВО', 'LEFT'],
    leg: ['Участок', 'Leg'],
    loadInfo: ['Информация по загрузке', 'Load info'],
    localTime: ['Локальное время', 'Local time'],
    longitude: ['долгота', 'longitude'],
    manualEdit: ['Ручное редактирование', 'Manual edit'],
    missing: ['отсутствует', 'missing'],
    native: ['Встроенный', 'Native'],
    new: ['Новые', 'New'],
    next: ['Следующий', 'Next'],
    noname: ['Безымянный', 'Noname'],
    notLoaded: ['Не загружен', 'Not loaded'],
    notSelected: ['Не выбрано', 'Not selected'],
    ok: ['ОК', 'OK'],
    passInfo: ['Информация о пассажирах', 'Passenger info'],
    permanent: ['Постоянный', 'Permanent'],
    pilotSignature: ['Подпись пилота', 'Pilot signature'],
    program: ['{{company}} EFB', '{{company}} EFB'],
    readAll: ['Прочитать все', 'Read all'],
    reload: ['Перезагрузить', 'Reload'],
    remove: ['Удалить', 'Remove'],
    replaceAll: ['Заменить все', 'Replace all'],
    reportType: ['Вид доклада', 'Type of report'],
    reset: ['Сбросить', 'Reset'],
    right: ['ВПРАВО', 'RIGHT'],
    row: ['Ряд', 'Row'],
    search: ['Поиск', 'Search'],
    select: ['Выбрать', 'Select'],
    send: ['Отправить', 'Send'],
    sendData: ['Отправить данные', 'Send data'],
    sendingSuccess: ['Успешная отправка', 'Sending success'],
    sendToServer: ['Отправить на сервер', 'Send to server'],
    settings: ['Настройки', 'Settings'],
    show: ['Показать', 'Show'],
    showDetails: ['Показать детали', 'Show details'],
    showMore: ['Показать больше', 'Show more'],
    sign: ['Подпись', 'Sign'],
    signOut: ['Выход из системы', 'Sign out'],
    speed: ['скорость', 'speed'],
    success: ['Успешно', 'Success'],
    time: ['Время', 'Time'],
    type: ['Тип', 'Type'],
    updated: ['Обновлено', 'Updated'],
    value: ['Значение', 'Value'],
    version: ['Версия', 'Version'],
    viewer: ['Программа просмотра', 'Viewer'],
    warningMessage: ['Предупреждение', 'Warning message'],
    labels: {
        acLimitations: ['Ограничения ВС', 'AC limitations'],
        addReport: ['Добавить доклад', 'Add report'],
        additionalInfo: ['Дополнительная информация', 'Additional info'],
        airportDocuments: ['Документы аэропорта', 'Airport documents'],
        attachments: ['Вложения', 'Attachments'],
        briefing: ['Брифинг', 'Briefing'],
        checkList: ['Контрольный список', 'Check list'],
        count: ['количество', 'count'],
        createdAt: ['Создано в', 'Created at'],
        createdDate: ['Дата создания', 'Created date'],
        crew: ['Экипаж', 'Crew'],
        crewTimeInfo: ['Рабочее время экипажа', 'Crew time info'],
        curDuteTime: ['Длительность смены ', 'Current duty time '],
        dataNotSaved: ['Не все данные сохранены', 'Not all data are saved'],
        dataSaved: ['Данные сохранены', 'The data are saved'],
        decisionFuel: ['Топливо по решению КВС, КГ', 'Decision fuel, KG'],
        documents: ['Документы', 'Documents'],
        duteTimeNotStart: ['Рабочее время не началось', 'Duty time have not started'],
        enroute: ['Маршрут', 'Enroute'],
        enterAdditionalInfo: ['Введите дополнительную информацию', 'Enter additional info'],
        flightAttendants: ['Кабинный экипаж', 'Flight attendants'],
        flightCrew: ['Лётный экипаж', 'Flight crew'],
        flightLog: ['Полётные данные', 'Flight log'],
        flightTask: ['Полётное задание', 'Flight task'],
        flightTaskInfo: ['Данные по полётному заданию', 'Flight task info'],
        flightTasks: ['Полётные задания', 'Flight Tasks'],
        highlightDetectedPoint: ['Подсвечивать точку', 'Highlight detected point'],
        library: ['Библиотека', 'Library'],
        limitations: ['Ограничения', 'Limitations'],
        manualInput: ['Ручной ввод', 'Manual input'],
        meteo: ['Метео', 'Meteo'],
        noCrewInfo: ['Нет информации по экипажу', 'There is no crew information'],
        notifications: ['Уведомления', 'Notifications'],
        notice: ['НОТАМы', 'NOTAMs'],
        messages: ['Сообщения', 'Messages'],
        flightChat: ['Чат рейса', 'Flight chat'],
        ofpList: ['Список OFP', 'OFP list'],
        other: ['Прочие', 'Other'],
        partitions: ['Разделы', 'Partitions'],
        passengerList: ['Список пассажиров', 'Passenger list'],
        pilotFlying: ['Пилотирующий', 'Pilot flying'],
        preFlightBriefing: ['Подготовка к рейсу', 'Pre-flight briefing'],
        processOperations: ['Технологические операции', 'Process operations'],
        processOperationsShort: ['ТГО', 'Process operations'],
        reports: ['Доклады', 'Reports'],
        showRequiredOnly: ['Показать только необходимые', 'Show required only'],
        specialValue: ['Специальное значение', 'Special value'],
        summaryInfo: ['Итоговая информация', 'Summary info'],
        tableView: ['Табличный вид', 'Table view'],
        takeOffInfo: ['Данные по взлёту', 'Take Off information'],
        tasks: ['Задания', 'Tasks'],
        taskTitle: ['Заголовок задания', 'Task Title'],
        telegrams: ['Телеграммы', 'Telegrams'],
        timePickerType: ['Варианты выбора времени', 'Time picker type'],
        whatsNew: ['Что нового в версии', "What's New"],
        withClockOnly: ['Циферблат', 'With clock only'],
    },
    tables: {
        blockTime: ['Полётное', 'Block'],
        'to-la': ['TOLA', 'TOLA'],
        baggage: ['Багаж', 'Baggage'],
        blockFuel: ['Полная заправка', 'Block'],
        chair: ['Кресло', 'Chair'],
        checkIn: ['Рег-ция', 'Check-in'],
        class: ['Класс', 'Class'],
        crew: ['Экипаж', 'Crew'],
        duty: ['Рабочее', 'Duty'],
        engine: ['Двигатель', 'Engine'],
        flight: ['Лётное', 'Flight'],
        gender: ['Пол', 'Gender'],
        id: ['ID', 'ID'],
        landing: ['Посадка', 'Landing'],
        route: ['Маршрут', 'Route'],
        seat: ['Место', 'Seat'],
        takeOff: ['Взлёт', 'Takeoff'],
    },
};
